import"../../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as l}from"../../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{illustration as t}from"../../illustration-registry.js";const d=t("treasury",l`
        <svg width="168" height="168" viewBox="0 0 168 168" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_3736_596)">
            <g style="mix-blend-mode:multiply">
            <path d="M136.99 69.548L136.99 98.4521L26.88 98.4521L26.88 69.548L136.99 69.548Z" fill="#FABA00"/>
            </g>
            <g style="mix-blend-mode:multiply">
            <path d="M98.4522 26.88C98.4522 50.4449 117.555 69.548 141.12 69.548L141.12 98.4521C101.592 98.4521 69.5481 66.4082 69.5482 26.88L98.4522 26.88Z" fill="#8EDB7A"/>
            </g>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M141.036 98.4519C124.871 98.4333 109.961 93.0556 97.9872 83.9999C109.961 74.9441 124.871 69.5664 141.036 69.5477C141.064 69.5478 141.092 69.5478 141.12 69.5478L141.12 98.4518C141.092 98.4518 141.064 98.4518 141.036 98.4519Z" fill="white"/>
            <g style="mix-blend-mode:multiply">
            <path d="M98.4522 141.12C98.4522 117.555 117.555 98.4521 141.12 98.4521L141.12 69.548C101.592 69.548 69.5482 101.592 69.5482 141.12L98.4522 141.12Z" fill="#EA4A22"/>
            </g>
            </g>
            <defs>
            <clipPath id="clip0_3736_596">
            <rect width="116" height="116" fill="white" transform="translate(142 26) rotate(90)"/>
            </clipPath>
            </defs>
        </svg>
    `);export{d as Treasury};
